import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import axios from "axios";
import { Btn } from "@/components/Btn";
import WaveMark from "@/components/WaveMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [pkg, setPkg] = useState("");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        setPkg(data.package || "");
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (tries++ < 6) setTimeout(poll, 2000); else setState("pending");
      } catch { if (tries++ < 6) setTimeout(poll, 2000); else setState("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <section className="flex min-h-screen items-center bg-ink text-white">
      <div className="mx-auto max-w-[800px] px-6 py-40 text-center md:px-12">
        {state === "checking" && (<div data-testid="payment-checking"><Loader2 className="mx-auto animate-spin text-champagne" size={40} /><p className="mt-6 text-[11px] uppercase tracking-label text-white/60">Confirming your payment…</p></div>)}
        {state === "paid" && (
          <div data-testid="payment-success">
            <div className="mx-auto flex h-16 w-16 items-center justify-center border border-champagne text-champagne"><Check size={30} strokeWidth={1.5} /></div>
            <h1 className="mt-10 font-serif text-5xl tracking-tight md:text-6xl">Welcome to Wave Eleven.</h1>
            <p className="mt-6 text-xl text-champagne">Your project has officially started.</p>
            <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-white/70">We've received your {pkg ? `${pkg} ` : ""}project details and will be in touch shortly with the next steps. A confirmation is on its way to your inbox.</p>
            <div className="mt-10 flex justify-center"><Btn to="/" variant="gold" testid="success-home">Back to home</Btn></div>
            <WaveMark width={120} stroke="rgba(255,255,255,0.15)" className="mx-auto mt-16" />
          </div>
        )}
        {state === "pending" && (<div data-testid="payment-pending"><h1 className="font-serif text-4xl">Payment processing.</h1><p className="mt-4 text-white/70">Your payment is still being confirmed. You'll receive an email shortly — no need to pay again.</p><div className="mt-8 flex justify-center"><Btn to="/" variant="gold">Back to home</Btn></div></div>)}
        {state === "error" && (<div data-testid="payment-error"><h1 className="font-serif text-4xl">Something went wrong.</h1><p className="mt-4 text-white/70">We couldn't confirm this payment. Please contact info@waveeleven.co.uk.</p><div className="mt-8 flex justify-center"><Btn to="/start" variant="gold">Try again</Btn></div></div>)}
      </div>
    </section>
  );
}
